import type { RuntimeAnswer, TaskAnswerEntry } from '../../types/runtime';

interface Props {
  answer: RuntimeAnswer;
}

function OverdueRow({ task }: { task: TaskAnswerEntry }) {
  const matterLabel = task.matter_description ?? task.matter_number ?? '(unknown matter)';
  return (
    <li className="flex flex-wrap items-baseline gap-2 py-1">
      <span className="font-medium">{task.title ?? '(untitled)'}</span>
      {task.priority && task.priority !== 'medium' && (
        <span className="rounded bg-rose-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-rose-800">
          {task.priority}
        </span>
      )}
      {task.due_date && (
        <span className="text-xs text-rose-800">due {task.due_date.slice(0, 10)}</span>
      )}
      <span className="text-xs text-rose-700">— on {matterLabel}</span>
    </li>
  );
}

export function TaskOverdueCard({ answer }: Props) {
  const tasks = answer.tasks ?? [];
  return (
    <article className="rounded-lg border border-rose-200 bg-rose-50 p-4 text-sm text-rose-900">
      <div className="mb-2 flex items-center gap-2">
        <span className="rounded bg-rose-200 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide">
          Overdue
        </span>
        {typeof answer.task_count === 'number' && (
          <span className="text-xs text-rose-800">
            {answer.task_count} task{answer.task_count === 1 ? '' : 's'}
          </span>
        )}
      </div>
      {tasks.length > 0 ? (
        <ul className="divide-y divide-rose-100">
          {tasks.map((t) => (
            <OverdueRow key={t.task_id ?? t.title ?? Math.random().toString(36)} task={t} />
          ))}
        </ul>
      ) : (
        <p className="whitespace-pre-line leading-relaxed">{answer.content}</p>
      )}
    </article>
  );
}
